import { ROUTES } from '@/constants/routes';
import { BusinessDetails } from '@/types/businesses';
import { Card, Stack, Typography } from '@mui/material';
import { SVLink } from '../core';

type BusinessDetailsViewProps = {
  businessDetails: BusinessDetails;
};

export default function BusinessDetailsView({
  businessDetails,
}: BusinessDetailsViewProps) {
  const { uuid, aggregateInfo } = businessDetails;

  return (
    <Card variant="fullHeight">
      <Typography variant="h5" mb={2}>
        View
      </Typography>
      <Stack spacing={2}>
        <SVLink
          to={`${ROUTES.BANK_ACCOUNT_APPLICATIONS_DRAFT}?business_id=${uuid}`}>
          Draft Bank Applications
        </SVLink>
        <SVLink to={`${ROUTES.BANK_ACCOUNTS}?business_id=${uuid}`}>
          Active Bank Accounts ({aggregateInfo.totalActiveBankAccounts})
        </SVLink>
        <SVLink to={`${ROUTES.CUSTOMERS}?business_id=${uuid}`}>
          Associated Customers ({aggregateInfo.totalMembers})
        </SVLink>
      </Stack>
    </Card>
  );
}
